import PropTypes from 'prop-types';
import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Icon } from '~/components'

import { toggleArticleBookmark, toggleArticleFlare } from '~/actions/article'

class Ranking extends React.Component {

    static propTypes = {
		articleID: PropTypes.number.isRequired,
		flared: PropTypes.string,
		bookmarked: PropTypes.string,
	};

    bookmark = () => {
		this.props.toggleArticleBookmark(this.props.articleID)
	};

    flare = () => {
		this.props.toggleArticleFlare(this.props.articleID)
	};

    render() {
		return (
			<p className="large text-right">
				<span className="clickable mright15 mright10-xs" onClick={this.flare}>
					<Icon icon={'flares'} className={this.props.flared ? 'text-mid-danger' : 'text-dark-gray'} />
				</span>
				<span className="clickable" onClick={this.bookmark}>
					<Icon icon={'bookmarks'} className={this.props.bookmarked ? 'text-mid-success' : 'text-dark-gray'} />
				</span>
        	</p>
		)
	}
}

const mapDispatchToProps = dispatch => bindActionCreators({ toggleArticleBookmark, toggleArticleFlare }, dispatch);

export default connect(
    null,
    mapDispatchToProps
)(Ranking);




// WEBPACK FOOTER //
// ./src/js/views/Article/components/Ranking.js